import { Component, OnInit, ChangeDetectionStrategy, OnDestroy, HostListener } from '@angular/core';
import { WidgetState } from 'src/app/widget-auth/state/widget.state';
import { Observable, Subject } from 'rxjs';
import { Select, Store } from '@ngxs/store';
import { takeUntil, filter } from 'rxjs/operators';
import { ViewActions } from 'src/app/view/state/view.actions';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { GoogleAnalyticsService } from 'ngx-google-analytics';
import { PendoService } from 'src/app/shared/pendo.service';
import 'reflect-metadata';
import 'zone.js';
@Component({
  selector: 'app-root',
  templateUrl: './app-viewer.component.html',
  styleUrls: ['./app-viewer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppViewerComponent implements OnInit, OnDestroy {
  @Select(WidgetState.getInputEnabled)
  inputEnabled$: Observable<boolean>;

  title = 'Biodigital Human';
  ngUnsubscribe = new Subject();

  constructor(
    private store: Store,
    private router: Router,
    private ga: GoogleAnalyticsService,
    private pendoService: PendoService
  ) {
  }

  ngOnInit() {
    this.initPendo();
    this.initPageAnalytics();
    this.initInputObserver();
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  initPendo() {
    this.pendoService.appendScript();

    // User tracking on the viewer is always anonymous
    this.pendoService.initialize({
      visitor: {
        id: ''
      },
      account: {}
    });


  }
  
  initInputObserver() {
    this.inputEnabled$.pipe(
      takeUntil(this.ngUnsubscribe)
    ).subscribe(enabled => {
      this.store.dispatch(new ViewActions.SetInputEnabled(enabled));
    });
  }

  initPageAnalytics() {
    // log subsequent in app route changes (i.e., /error)
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        takeUntil(this.ngUnsubscribe)
      )
      .subscribe((event: NavigationEnd) => {
        const url = event.urlAfterRedirects;
        this.ga.pageView(url);
      });
  }
}
